require('./index.scss')

import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { hasRelatedAssetsSelector } from '@/selectors'

import Header from './components/Header'
import RelatedAsset from './components/RelatedAsset'

const GTM_TYPE = 'gtm/onCartRecommendations'

const RelatedAssets = () => {
  const hasRelatedAssets = useSelector(hasRelatedAssetsSelector)
  const assetsOrder = useSelector(state => state.relatedAssets.assetsOrder)
  const dispatch = useDispatch()

  useEffect(() => {
    if (hasRelatedAssets) { dispatch({ type: GTM_TYPE }) }
  }, [hasRelatedAssets])

  return (
    <If condition={hasRelatedAssets}>
      <div className='related-assets' data-testid='related-products'>
        <Header />
        <div className='related-assets__content'>
          <ul className='product-info'>
            {assetsOrder.map(key => (
              <li className='product-info__wrapper' key={key}>
                <RelatedAsset assetKey={key} />
              </li>
            ))}
          </ul>
        </div>
      </div>
    </If>
  )
}
export default RelatedAssets
